import { useState, useRef, useEffect } from "react";
import { Button } from "./ui/button";
import { Calendar } from "./ui/calendar";
import { CalendarIcon, X } from "lucide-react";
import { format } from "date-fns";
import { it } from "date-fns/locale";

export default function CustomDatePicker({ 
  value, 
  onChange, 
  placeholder = "Seleziona data",
  className = ""
}) {
  const [open, setOpen] = useState(false);
  const pickerRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (pickerRef.current && !pickerRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    if (open) {
      document.addEventListener("mousedown", handleClickOutside);
      document.addEventListener("touchstart", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, [open]);

  const handleSelect = (date) => {
    onChange(date ? date.toISOString() : null);
    setOpen(false);
  };

  const handleClear = (e) => {
    e.stopPropagation();
    onChange(null);
  };

  return (
    <div className={`relative ${className}`} ref={pickerRef}>
      <Button
        type="button"
        variant="outline"
        className="w-full justify-start text-left font-normal bg-secondary h-9 text-sm"
        onClick={() => setOpen(!open)}
        data-testid="task-deadline-btn"
      >
        <CalendarIcon className="mr-2 h-4 w-4" />
        {value 
          ? format(new Date(value), "dd/MM/yyyy", { locale: it })
          : placeholder
        }
        {value && (
          <X 
            className="ml-auto h-4 w-4 opacity-50 hover:opacity-100" 
            onClick={handleClear}
          />
        )}
      </Button>
      
      {open && (
        <div className="absolute left-0 top-full mt-1 z-50 bg-popover border border-border rounded-md shadow-lg p-0 animate-in fade-in-0 zoom-in-95">
          <Calendar
            mode="single"
            selected={value ? new Date(value) : undefined}
            onSelect={handleSelect}
            locale={it}
            data-testid="task-deadline-calendar"
          />
        </div>
      )}
    </div>
  );
}
